import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { RenderNumber } from "Utils/renderField/renderReadField";
import LoadMask from "Utils/LoadMask/LoadMask";
import { BoletaSalidaApi } from "./api/BoletaSalidaApi";
import { DetallesTable } from "./DetallesTable";
import { DetallesSobranteTable } from "./DetallesSobranteTable";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";
const logo_img = require("assets/img/logo.png");
const produccion_activo = require(`assets/img/icons/produccion_activo.png`);
const linea_img = require("assets/img/icons/linea.png");

export const DatosBoleta = ({ salidaId }) => {
    const fechaHoraImpresion = moment().format("DD/MM/YYYY HH:mm:ss");

    const { getSalidaBodega, cargando: cargandoDetalle } = BoletaSalidaApi();

    const [salidaDetalle, setSalidaDetalle] = useState({});

    const GetSalidaDetalle = async () => {
        try {
            const data = await getSalidaBodega(salidaId);
            setSalidaDetalle(data);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle de la salida",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setSalidaDetalle({});
        }
    };

    useEffect(() => {
        GetSalidaDetalle();
    }, [salidaId]);

    if (cargandoDetalle) {
        return (
            <LoadMask loading={cargandoDetalle} blur>
                <div style={{ height: "400px" }}></div>
            </LoadMask>
        );
    }

    return (
        <div className="col-12 p-0">
            <div className="row contenido-impresion verde-secundario d-flex justify-content-center">
                <div className="col-12 row">
                    <div className="col-12 d-flex justify-content-center mt-0 mb-3">
                        <div className="col-11 pl-2">
                            <div className="row col-12 p-0 mt-3 d-flex justify-content-between align-items-center">
                                <img
                                    className="d-inline-block align-top"
                                    src={logo_img}
                                    alt="Logo"
                                    height="50px"
                                />
                                <label className="p-0 m-0">
                                    ACOPIO ERSA KM. 7.5 CARRETERA A TULATE
                                </label>
                                <div className="ml-4 mr-4"></div>
                            </div>
                        </div>
                    </div>
                    {/* DATOS SALIDA */}
                    <div className="col-12 d-flex justify-content-center mt-0">
                        <div className="col-11">
                            <div className="row col-12 p-0 mt-2 mb-3 align-items-start">
                                <div className="col-12 p-0 fondo">
                                    <div className="col-12 d-flex flex-column pl-0">
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={produccion_activo}
                                                alt="Usuario"
                                                className="title_img mr-2"
                                            />
                                            <img
                                                src={linea_img}
                                                alt="Linea"
                                                className="title_img mr-2"
                                            />
                                            <h6 className="text-black mb-0">
                                                Boleta de salida de producto no
                                                conforme hacia almacenes
                                                MP/Reclasificación
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 py-2">
                                <div className="col-7 p-0 d-flex align-items-center">
                                    <div className="col-12 d-flex align-items-baseline">
                                        <label className="p-0 m-0">
                                            NÚMERO DE SALIDA
                                        </label>
                                        <h5 className="gris bold pl-2 mb-0">
                                            {salidaDetalle.numero}
                                        </h5>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <span className="gris">
                                            Fecha de impresión:
                                        </span>
                                        <span className="gris">
                                            {fechaHoraImpresion}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 pt-1">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            FECHA DE SALIDA
                                        </label>
                                        <span className="gris">
                                            {salidaDetalle.fecha_con_desfase
                                                ? moment(
                                                      salidaDetalle.fecha_con_desfase,
                                                  ).format(
                                                      "DD/MM/YYYY - HH:mm",
                                                  )
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">TURNO</label>
                                        <span className="gris">
                                            {moment(
                                                salidaDetalle.fecha_con_desfase,
                                            ).hour() < 18
                                                ? "Diurno"
                                                : "Nocturno"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            TIPO DE SALIDA
                                        </label>
                                        <span className="gris">
                                            {salidaDetalle.tipo_salida_display}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            DESTINO
                                        </label>
                                        <span className="gris">
                                            {salidaDetalle.tipo_destino_display}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            CANTIDAD EN PACAS
                                        </label>
                                        <span className="gris">
                                            <RenderNumber
                                                value={
                                                    salidaDetalle.total_pacas
                                                }
                                                decimalScale={0}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            CANTIDAD EN KG
                                        </label>
                                        <span className="gris">
                                            <RenderKilogramo
                                                value={
                                                    salidaDetalle.total_pacas_kg
                                                }
                                                decimalScale={2}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {salidaDetalle.total_kg_secos_sobrante > 0 && (
                                <div className="row col-12 p-0 mt-2">
                                    <div className="col-7 p-0">
                                        <div className="col-12 d-flex flex-column">
                                            <label className="p-0 m-0">
                                                KG SECOS SOBRANTES
                                            </label>
                                            <span className="gris">
                                                <RenderKilogramo
                                                    value={
                                                        salidaDetalle.total_kg_secos_sobrante
                                                    }
                                                    decimalScale={2}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            OBSERVACIONES
                                        </label>
                                        <span className="gris">
                                            {salidaDetalle.observaciones}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* TABLA DE DETALLES */}
                    <div className="col-12 d-flex justify-content-center p-0">
                        <div className="col-11 form-group np-r p-0 mt-3 mb-1">
                            <DetallesTable salidaDetalle={salidaDetalle} />
                            <DetallesSobranteTable
                                salidaDetalle={salidaDetalle}
                            />
                        </div>
                    </div>
                    {/* FIRMAS */}
                    <div className="my-2 w-100 h-auto"></div>
                    <div className="col-12 d-flex justify-content-center mt-5 p-0">
                        <div className="col-11">
                            <div className="row col-12 p-0 d-flex align-items-center">
                                <div className="col-6 p-0">
                                    <div className="col-12 d-flex flex-row align-items-end">
                                        <div className="col-6">
                                            <label className="p-0 m-0">
                                                FIRMA BODEGA
                                            </label>
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="espacio-firma mb-1"
                                                type="text"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 p-0">
                                    <div className="col-12 d-flex flex-row align-items-end">
                                        <div className="col-6">
                                            <label className="p-0 m-0">
                                                FIRMA PRODUCCIÓN
                                            </label>
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="espacio-firma mb-1"
                                                type="text"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                        <div className="col-11">
                            <div className="row col-12 p-0 mt-3">
                                <div className="col-8 p-0">
                                    <div className="col-12 d-flex flex-column"></div>
                                </div>
                                <div className="col-4 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <span className="gris">
                                            {/* TODO: Actualizar */}
                                            ERSA-F-GO-025-06
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
